// @flow
import type { Locale } from './duck';

import { VALID_LOCALES } from './duck';

export function processLanguage(l: ?string): ?Locale {
  if (!l) {
    return;
  }
  let new_l = l;
  if (new_l.length > 2) {
    new_l = l.substring(0, 2).toLowerCase();
  }
  new_l = new_l.toLowerCase();

  if (VALID_LOCALES.indexOf(new_l) === -1) {
    return;
  }
  return (new_l: any);
}



// WEBPACK FOOTER //
// ./src/modules/locale/utils.js